import HTTP from '@/common/HTTP'
import { mutationTypes, actionTypes } from './SessionTypes'

// initial state
const state = {
  session: null,
  authenticated: false,
  attemptingLogin: false,
  loginFailed: false,
  authorities: [],
  analysisTypes: [],
  onetimePwd: false,
  twoFaRequired: false,
  twoFactorEmailCode: false
}

// getters
const getters = {
  authenticated: state => state.authenticated,
  analysisTypes: state => state.analysisTypes,
  attemptingLogin: state => state.attemptingLogin,
  loginFailed: state => state.loginFailed,
}

// mutations
const mutations = {
  [mutationTypes.ATTEMPTING_LOGIN](state) {
    state.attemptingLogin = true
    state.loginFailed = false
  },

  [mutationTypes.LOGIN](state, session) {
    state.session = session
    state.onetimePwd = session.user.onetimePwd
    state.authenticated = true
    state.attemptingLogin = false
    state.twoFactorEmailCode = false
  },

  [mutationTypes.LOGIN_FAILED](state) {
    state.loginFailed = true
    state.attemptingLogin = false
    state.twoFaRequired = false
    state.twoFactorEmailCode = false
  },

  [mutationTypes.LOGOUT](state) {
    state.authenticated = false
    state.twoFaRequired = false
    state.twoFactorEmailCode = false
    state.session = null
  },

  [mutationTypes.SET_AUTHORITIES](state, authorities) {
    state.authorities = authorities
  },

  [mutationTypes.SET_ANALYSIS_TYPES](state, authorities) {
    state.analysisTypes = authorities
  },

  [mutationTypes.SET_2FA_REQUIRED](state) {
    state.twoFaRequired = true
    state.attemptingLogin = false
  },

  [mutationTypes.PRE_AUTH_USER](state, session) {
    state.session = session
    state.onetimePwd = session.user.onetimePwd
    state.twoFactorEmailCode = true
    state.authenticated = true
    state.attemptingLogin = false
  },
}

const actions = {
  [actionTypes.LOGIN]({ commit, state }, { username, password, totp }) {
    return new Promise((resolve, reject) => {
      commit(mutationTypes.ATTEMPTING_LOGIN)

      const params = new URLSearchParams()
      params.append('username', username)
      params.append('password', password)
      params.append('totp', totp)

      HTTP.post('auth/login', params)
        .then(({ data: { access_token, expires_in } }) =>
          HTTP.get('users/me', {
            // eslint-disable-next-line
            headers: {Authorization: `Bearer ${access_token}`}
          }).then(({ data }) => {
            commit(mutationTypes.LOGIN, { accessToken: access_token, expiresIn: expires_in, user: data })
            resolve(state)
          })
        )
        .catch((error) => {
          if (error.response.status === 403 && !state.twoFaRequired) {
            commit(mutationTypes.SET_2FA_REQUIRED)
          } else if (error.response.status === 403 && state.twoFaRequired) {
            commit(mutationTypes.LOGIN_FAILED)
            commit(mutationTypes.SET_2FA_REQUIRED)
          } else {
            commit(mutationTypes.LOGIN_FAILED)
          }
          reject()
        })
    })
  },

  [actionTypes.CODE]({ commit, state }, { username, password, totp, tfec }) {
    return new Promise((resolve, reject) => {
      commit(mutationTypes.ATTEMPTING_LOGIN)

      const params = new URLSearchParams()
      params.append('username', username)
      params.append('password', password)
      params.append('totp', totp)
      params.append('tfec', tfec)


      HTTP.post('auth/login', params)
        .then(({ data: { access_token, expires_in } }) =>
          HTTP.get('users/me', {
            // eslint-disable-next-line
            headers: {Authorization: `Bearer ${access_token}`}
          }).then(({ data }) => {
            commit(mutationTypes.PRE_AUTH_USER, { accessToken: access_token, expiresIn: expires_in, user: data })
            resolve(state)
          })
        )
        .catch((error) => {
          console.log(error);
          if (error.response.status === 403 && !state.twoFaRequired) {
            commit(mutationTypes.SET_2FA_REQUIRED)
          } else if (error.response.status === 403 && state.twoFaRequired) {
            commit(mutationTypes.LOGIN_FAILED)
            commit(mutationTypes.SET_2FA_REQUIRED)
          } else {
            commit(mutationTypes.LOGIN_FAILED)
          }
          reject()
        })
    })
  },

  [actionTypes.FETCH_AUTHORITIES]({ commit }) {
    return HTTP.get('authorities')
        .then(({ data }) => {
          commit(mutationTypes.SET_AUTHORITIES, data)
        }).catch(() => {})
  },

  [actionTypes.VERIFY_CODE]({ commit, state }, { tfec, accessToken, expiresIn }) {
    return new Promise((resolve, reject) => {
      commit(mutationTypes.ATTEMPTING_LOGIN)

      const params = new URLSearchParams()
      params.append('tfec', tfec)

      HTTP.post('users/verifyCode', params )
        .then(({ data }) => {
        commit(mutationTypes.LOGIN, { accessToken: accessToken, expiresIn: expiresIn, user: data })
        resolve(state)
          })
        .catch(() => {
          commit(mutationTypes.LOGIN_FAILED)
          reject()
        })
    })
  },

  [actionTypes.FETCH_ANALYSIS_TYPES]({ commit }) {
    return HTTP.get('/continuous-recording-analysis-types')
      .then(({ data }) => {
        commit(mutationTypes.SET_ANALYSIS_TYPES, data)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Session.js